import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";

function AddManagerPatient(props) {
  const [formData, setName] = useState({
    pName: "",
    caseName: "",
    case_history: "",
  });
  const [Gender, setGender] = useState("");
  const mangerId = localStorage.getItem("ManegerId");
  const [LastPatientId, setLastPatientId] = useState([]);

  const navigate = useHistory();

  useEffect(() => {
    LoadPatient();
  }, []);
  const LoadPatient = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetLastPatientId`).then((res) => {
      const lastPatient = res.data;
      //console.log("Last p_id:", lastPatient.p_id)

      const newPatientId = parseInt(lastPatient) + 1;
      setLastPatientId(newPatientId.toString());
    });
  };
  const Patientsubmit = async (e) => {
    e.preventDefault();
    //console.log("formData", formData)

    // ---------------------------------------------------

    if (formData.pName === "" || Gender === "" || formData.caseName === "") {
      if (formData.pName === "") {
        Swal.fire({
          title: "Error",
          text: "Name Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (formData.caseName === "") {
        Swal.fire({
          title: "Error",
          text: "Case Name Required",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (Gender === "") {
        Swal.fire({
          title: "Error",
          text: "Select Geder",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
    } else {
      // formData.first.charAt(0).toUpperCase() + formData.first.slice(1)
      const datavalue = {
        patient_Nm:
          formData.pName.charAt(0).toUpperCase() + formData.pName.slice(1),
        p_Gender: Gender,
        p_id: LastPatientId,
        case_Name:
          formData.caseName == null || formData.caseName == ""
            ? "0"
            : formData.caseName,
        userId: mangerId,
        case_history: formData.case_history,
        assessment_blueprint: formData.assessment_blueprint,
      };

      //console.log("json data", JSON.stringify(datavalue))
      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/LAddManegerPatient`,
        //   url: `${process.env.REACT_APP_RAZZLE_APP_API_URL}/account/login`,
        data: JSON.stringify(datavalue),
        headers: { "Content-Type": "application/json" },
        json: true,
      };
      axios(authOptions)
        .then((res) => {
          //console.log("success", res.data.SuccessResult)
          if (res.data.SuccessResult === "already") {
            Swal.fire({
              title: "Error",
              text: "Id Already inserted",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1e2b38"
            });
          } else {
            setName({ pName: "", caseName: "" });
            Swal.fire({
              title: "Success",
              text: "Case Added Successfully",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1e2b38"
            }).then(function () {
              // window.location.pathname = "/IntentAns";
              navigate.push("/LManagerPatientList");
            });
          }
        })
        .catch((error) => {
          //console.log("error occur", error);
        });
    }
  };

  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };
  const handleChangeDrp = (event) => {
    setGender(event.target.value);
    //console.log("selected emo", event.target.value)
  };
  const BackFunc = () => {
    navigate.push("/index");
  };

  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title">Add Case</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block"
                  style={{backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38"}}
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-2 col-sm-2"></div>
            <div className="col-md-8 col-sm-8">
              <div className="card card-box">
                <div className="card-head">
                  <header>Add Case</header>
                </div>
                <div className="card-body " id="bar-parent1">
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={Patientsubmit}
                  >
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Case ID
                      </label>
                      <div className="col-sm-9 pt-3">
                        <p>{LastPatientId}</p>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Case Name
                      </label>
                      {/* <i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} /> */}
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.pName}
                          onChange={handleChange}
                          name="pName"
                          className="form-control"
                          id="simpleFormEmail"
                          placeholder="Enter Case Name"
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      {/* <div className="card-body " id="bar-parent10"> */}

                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Gender
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="form-control  select2"
                          value={Gender}
                          onChange={handleChangeDrp}
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>

                      {/* </div> */}
                    </div>
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Case Description
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.caseName}
                          onChange={handleChange}
                          name="caseName"
                          className="form-control"
                          id="simpleFormEmail"
                          placeholder="Enter Case Description"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Case History
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          className="form-control"
                          name="case_history"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.case_history}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Assessment Blueprint
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          className="form-control"
                          name="assessment_blueprint"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.assessment_blueprint}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 text-end">
                        <button
                          type="submit"
                          className="btn d-inline-block"
                          style={{backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38"}}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddManagerPatient;
